import { InputMask } from "@react-input/mask";
import { Controller } from "react-hook-form";

const MaskedTextInput = ({
  id,
  label,
  placeholder,
  mask,
  replacement,
  className = "",
  labelClass = "",
  inputClass = "",
  error,
  control,
  name,
  defaultValue = "",
  ...props
}) => {
  return (
    <div className={`flex flex-col gap-3 ${className}`}>
      {label && (
        <label htmlFor={id} className={`body-copy-small-text ${labelClass}`}>
          {label}
        </label>
      )}

      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field }) => (
          <InputMask
            {...field}
            {...props}
            id={id}
            component="input"
            mask={mask}
            replacement={replacement}
            placeholder={placeholder}
            className={`text-20px-23px text-ff-purple rounded-[21.5px] px-6 py-1 w-54 outline-none border-none ${inputClass}`}
          />
        )}
      />

      {error && <p className="text-red-500 text-xs mt-1">{error.message}</p>}
    </div>
  );
};

export default MaskedTextInput;
